// 2023 - 2024 images :
import morgan from "../assets/eboard/2023-2024/Morgan_Li.jpeg";
import matthew from "../assets/eboard/2023-2024/Matthew_Haynes.jpg";
import chris from "../assets/eboard/2023-2024/Christopher_Varghese.jpg";
import diego from "../assets/eboard/2023-2024/Diego_Cabiya.jpg";
import nitin from "../assets/eboard/2023-2024/Nitin_Pai.jpeg";
import amit from "../assets/eboard/2023-2024/Amit_Tzadok.jpg";

// 2024 - 2025 images :
import maxence from "../assets/eboard/2024-2025/Maxence_Gilloteaux.JPG";
import vaishnavi from "../assets/eboard/2024-2025/Vaishnavi_Lokhande.jpg";
import ehsanul from "../assets/eboard/2024-2025/Ehsanul_Haque.jpeg";
import aaron from "../assets/eboard/2024-2025/Aaron_Li.jpg";

// 2025 - 2026 images :
import samuel from "../assets/eboard/2025-2026/samuel_eboard.png";
import rodney from "../assets/eboard/2025-2026/rodney_eboard.png";
import jack from "../assets/eboard/2025-2026/jack_eboard.png";
import mahin from "../assets/eboard/2025-2026/mahin_eboard.png";
import josiah from "../assets/eboard/2025-2026/josiah.png";
import abou from "../assets/eboard/2025-2026/abou.jpeg";

// 2026 - 2027 images :
import alex from "../assets/eboard/2026-2027/alex.png";
import mafruha from "../assets/eboard/2026-2027/mafruha.jpg";
import tashawna from "../assets/eboard/2026-2027/tashawna.png";
import oscar from "../assets/eboard/2026-2027/oscar.jpg";
import imman from "../assets/eboard/2026-2027/imman.jpg";
import mokshada from "../assets/eboard/2026-2027/mokshada.jpg";

export const eBoardData = {
  "2023-2024": [
    {
      id: 1,
      name: "Morgan Li",
      role: "President",
      image: morgan,
      linkedin: "https://www.linkedin.com/in/li-morgan/",
    },
    {
      id: 2,
      name: "Matthew Haynes",
      role: "Vice President",
      image: matthew,
      linkedin: "https://www.linkedin.com/in/matthayn/",
    },
    {
      id: 3,
      name: "Christopher Vargese",
      role: "Software Engineering Chair",
      image: chris,
      linkedin: "https://www.linkedin.com/in/chris-varghese/",
    },
    {
      id: 4,
      name: "Diego Cabiya",
      role: "Public Relations Coordinator",
      image: diego,
      linkedin: "https://www.linkedin.com/in/dvcabiya/",
    },
    {
      id: 5,
      name: "Mafruha Manal",
      role: "Events Coordinator",
      image: mafruha,
      linkedin: "https://www.linkedin.com/in/mafruhamanal/",
    },
    {
      id: 6,
      name: "Nitin Pai",
      role: "Secretary",
      image: nitin,
      linkedin: "https://www.linkedin.com/in/nitin-pai/",
    },
    {
      id: 7,
      name: "Amit Tzadok",
      role: "Treasurer",
      image: amit,
      linkedin: "https://www.linkedin.com/in/amit-tzadok/",
    },
  ],

  "2024-2025": [
    {
      id: 8,
      name: "Mafruha Manal",
      role: "President",
      image: mafruha,
      linkedin: "https://www.linkedin.com/in/mafruhamanal/",
    },
    {
      id: 9,
      name: "Alexandra Gelinas",
      role: "Vice President",
      image: alex,
      linkedin: "https://www.linkedin.com/in/ajgelinas/",
    },
    {
      id: 10,
      name: "Maxence Gilloteaux",
      role: "Software Engineering Chair",
      image: maxence,
      linkedin: "https://www.linkedin.com/in/maxenceglt/",
    },
    {
      id: 11,
      name: "Vaishnavi Lokhande",
      role: "Public Relations Coordinator",
      image: vaishnavi,
      linkedin: "https://www.linkedin.com/in/vaishnavi-lokhande000/",
    },
    {
      id: 12,
      name: "Ehsanul Haque",
      role: "Events Coordinator",
      image: ehsanul,
      linkedin: "https://www.linkedin.com/in/ehsanul-haque-047456265/",
    },
    {
      id: 13,
      name: "Aaron Li",
      role: "Secretary",
      image: aaron,
      linkedin: "https://www.linkedin.com/in/rbgk/",
    },
    {
      id: 14,
      name: "Amit Tzadok",
      role: "Treasurer",
      image: amit,
      linkedin: "https://www.linkedin.com/in/amit-tzadok/",
    }
  ],
  "2025-2026": [
    {
      id: 8,
      name: "Alexandra Gelinas",
      role: "President",
      image: alex,
      linkedin: "https://www.linkedin.com/in/ajgelinas/",
    },
    {
      id: 9,
      name: "Mafruha Manal",
      role: "Vice President",
      image: mafruha,
      linkedin: "https://www.linkedin.com/in/mafruhamanal/",
    },
    {
      id: 10,
      name: "Samuel Winkens",
      role: "Software Engineering Chair",
      image: samuel,
      linkedin: "https://www.linkedin.com/in/sam-winkens/",
    },
    {
      id: 11,
      name: "Vaishnavi Lokhande",
      role: "Public Relations Coordinator",
      image: vaishnavi,
      linkedin: "https://www.linkedin.com/in/vaishnavi-lokhande000/",
    },
    {
      id: 12,
      name: "Jack Walsh",
      role: "Events Coordinator",
      image: jack,
      linkedin: "https://www.linkedin.com/in/jackwalsh27/",
    },
    {
      id: 13,
      name: "Rodney Garnett",
      role: "Treasurer",
      image: rodney,
      linkedin: "https://www.linkedin.com/in/rodney-garnett-8830a4276/",
    },
    {
      id: 14,
      name: "Mahin Ahmed",
      role: "Undergrad Representative",
      image: mahin,
      linkedin: "https://www.linkedin.com/in/mahin-ahmed-910121307/",
    },
    {
      id: 15,
      name: "Josiah Gray",
      role: "Undergrad Representative",
      image: josiah,
      linkedin: "https://www.linkedin.com/in/josiahgraycs/",
    },
    {
      id: 16,
      name: "Aboubakary Traore",
      role: "Undergrad Representative",
      image: abou,
      linkedin: "https://www.linkedin.com/in/aboubakary/",
    }
  ],
  "2026-2027": [
    {
      id: 17,
      name: "Alexandra Gelinas",
      role: "President",
      image: alex,
      linkedin: "https://www.linkedin.com/in/ajgelinas/",
    },
    {
      id: 18,
      name: "Aboubakary Traore",
      role: "Vice President",
      image: abou,
      linkedin: "https://www.linkedin.com/in/aboubakary/",
    },
    {
      id: 19,
      name: "Mahin Ahmed",
      role: "Secretary",
      image: mahin,
      linkedin: "https://www.linkedin.com/in/mahin-ahmed-910121307/",
    },
    { id: 20, name: "Mafruha Manal", 
      role: "Senior Advisor",
      image: mafruha,
      linkedin: "https://www.linkedin.com/in/mafruhamanal/",
    }, 
    {
      id: 21,
      name: "Rodney Garnett",
      role: "Treasurer",
      image: rodney,
      linkedin: "https://www.linkedin.com/in/rodney-garnett-8830a4276/",
    },
    {
      id: 22,
      name: "Tashawna Anderson",
      role: "Public Relations Coordinator",
      image: tashawna,
      linkedin: "https://www.linkedin.com/in/tashawnaa/",
    },
    {
      id: 23,
      name: "Oscar Guerrero",
      role: "Software Engineering Chair",
      image: oscar,
      linkedin: "https://www.linkedin.com/in/oscargabrguerrero",
    },
    {
      id: 24,
      name: "Imman Ahmad",
      role: "Underclassmen Representative",
      image: imman,
      linkedin: "https://www.linkedin.com/in/imman-ahmad-733ba123a/",
    },
    {
      id: 25,
      name: "Mokshada Desale",
      role: "Underclassmen Representative",
      image: mokshada,
      linkedin: "https://www.linkedin.com/in/mokshada-desale-aaba84342",
    }
  ],
};
